import { Observable } from './druid/./druid/Observable';
import { _throw } from './druid/./druid/observable/throw';

Observable.throw = _throw;